import api from '@/api'
import axios from 'axios'

export async function collect(data) {
  return api.post('api/services/app/FrontendSupplier/Collect', data)
 }

 export async function doRemoveCollect(data) {
  return api.post('api/services/app/FrontendSupplier/DoRemoveCollect', data)
 }

 //获取收藏商品列表
export async function getCollectSuppliers(param) {
  var paramStr='SkipCount='+ (param.SkipCount>0?param.SkipCount-1:param.SkipCount);
  paramStr += '&MaxResultCount='+ param.MaxResultCount;
  return api.get('api/services/app/FrontendSupplier/GetMyCollectSuppliers?'+paramStr);
}


// WEBPACK FOOTER //
// ./src/api/supplier.js